import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import { TrackingHandler } from 'client/tracking/handler';
import { TrackingMap } from 'client/tracking/maps/calculators';
import { CustomHeroWrapper } from 'client/site-modules/shared/components/custom-hero-wrapper/custom-hero-wrapper';
import {
  CALCULATORS_BREADCRUMBS,
  CALCULATORS_SECTIONS_MAP,
  AUTO_CALCULATORS_TITLE,
  AUTO_CALCULATORS_SUBTITLE,
  AUTO_CALCULATORS_SUBTITLE_LIST,
} from 'client/site-modules/calculators/constants/calculators';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { CalculatorSection } from 'client/site-modules/calculators/components/calculator-section/calculator-section';
import { CalculatorsArticles } from 'site-modules/calculators/components/calculators-articles/calculators-articles';
import { NewUsedLandingHero } from 'client/site-modules/shared/components/new-used-landing-hero/new-used-landing-hero';

import './calculators.scss';

export const CALCULATORS_CONTENT_FILE_PATH = 'calculators/index';

export const CalculatorsUI = ({ content = DEFAULT_CONTENT }) => {
  const title = content?.title ?? AUTO_CALCULATORS_TITLE;
  const articlesContent = content.child('articles');
  const articleTitle = articlesContent.title;
  const articleAuthor = articlesContent.metadata('author').value();
  const articleDate = articlesContent.metadata('date').value();
  const articles = articlesContent.children();
  const UPDATED_CALCULATORS_SECTIONS_MAP = CALCULATORS_SECTIONS_MAP.slice(1);

  useEffect(() => {
    TrackingHandler.useMap(TrackingMap);
  }, []);

  const subTitleWithList = (
    <>
      {AUTO_CALCULATORS_SUBTITLE}
      <ul className="mb-0 mt-1">
        {AUTO_CALCULATORS_SUBTITLE_LIST.map((item, index) => (
          <li key={`calculator-subtitle-${index + 1}`}>{item}</li>
        ))}
      </ul>
    </>
  );

  return (
    <main id="main-content" tabIndex={-1} className="calculators" data-tracking-parent="edw-calculators-page">
      <NewUsedLandingHero
        title={title}
        subTitle={subTitleWithList}
        breadcrumbsData={CALCULATORS_BREADCRUMBS}
        childrenColumnSizes={{ xs: 12, lg: 12, xl: 12 }}
      >
        <Row className="mx-0_5 mx-md-0">
          <Col xs={12} lg={8} className="mb-2 bg-white overlap-module border-0 p-1_5 pos-r">
            <CustomHeroWrapper>
              <CalculatorSection key={CALCULATORS_SECTIONS_MAP[0].url} {...CALCULATORS_SECTIONS_MAP[0]} />
            </CustomHeroWrapper>

            {UPDATED_CALCULATORS_SECTIONS_MAP.map(section => (
              <CalculatorSection key={section.url} {...section} />
            ))}

            <hr className="mt-1_5 mb-2" />

            <ContentCollapse
              minHeight="35px"
              isEclipseFade={false}
              btnClasses="px-0_5 py-0 size-16 text-primary-darker"
              btnContainerClasses="py-0"
              justify="justify-content-start"
              showBtnBelow
              btnTextClasses="fw-normal"
              classes="size-16"
            >
              <CalculatorsArticles articles={articles} title={articleTitle} author={articleAuthor} date={articleDate} />
            </ContentCollapse>
          </Col>
          <Col lg={4} className="d-flex flex-column align-items-center">
            <AdUnit adName="mrect" position={'1'} all noRefresh />
          </Col>
          <div className="mb-2 mx-auto mx-lg-0 hidden-md-down">
            <AdUnit adName="edhighimpact" position={'1'} lg xl md renderWhenViewable={false} refreshable={false} />
          </div>
          <div className="my-2 mx-auto hidden-md-up">
            <AdUnit adName="medhighimpact" position={'1'} sm xs renderWhenViewable={false} refreshable={false} />
          </div>
        </Row>
      </NewUsedLandingHero>
    </main>
  );
};

CalculatorsUI.propTypes = {
  content: CmsEntities.Content,
};

export const Calculators = connectToModel(CalculatorsUI, {
  content: bindToContent(CALCULATORS_CONTENT_FILE_PATH),
});
